import $ from 'jquery';
import { Dropdown } from 'foundation-sites';

window.addEventListener('load', function(event) {

  // ### Dropdown Main Menu
  // Settings
  const dropDownEL = $('.js-lang');
  const dropDownOptions = {
    hover : true,
    hoverDelay: 100,
    hoverPane: true,
    position: 'top',
    alignment: 'right'
  }

  // Init
  const dropDownInstance = new Dropdown(dropDownEL, dropDownOptions);

});
